import React, { useState, useEffect } from "react";
import copy from "copy-to-clipboard";
import QRCode from "qrcode.react";
import IconDownload from "../../assets/icons/download.svg"
import Button from "../Button";
import { 
    TextContainer, 
    TextMessage, 
    LinkContainer, 
    ButtonLink, 
    ButtonLinkText, 
    ButtonShare, 
    ButtonShareText, 
    ButtonLinkCopy, 
    QrCodeContainer, 
    ModalFooter, 
    ButtonDownload 
} from "./styles";
import { ModalSharePropsInterface } from "./interfaces"
//Assets
import close from "../../assets/icons/close.svg";
import whatsapp from "../../assets/icons/whatsapp.svg";
import mail from "../../assets/icons/mailRed.svg";
import paper from "../../assets/icons/paper.svg";
import colors from "../../assets/css/colors";
import { ETypeTransactions } from "../../utils/typeTransactions";

const ModalShare = ({
    sendEmail,
    sendWhatsapp,
    text,
    type,
    codeForQr,
    isPowerUser,
    linkExternal,
    linkId,
    message,
    modalId,
    qrCode
}: ModalSharePropsInterface
): React.ReactElement => {
    const [buttonCopyText, setButtonCopyText] = useState("Copiar");

    useEffect(() => {
        setButtonCopyText("Copiar");
    }, [linkExternal, linkId])

    const linkDefinerAccordingToTheType = (): string | undefined => {
        if(type === ETypeTransactions.CREDIT_CARD){
            const link = `${linkId}`
            
            if(link.length > 45){
                return `${link.slice(0, 44)}...`;
            }
            
            return link
        }
        
        if(type === ETypeTransactions.PAY_ORDER){
            if(linkExternal){
                if(linkExternal?.length > 45){
                    return `${linkExternal.slice(0, 44)}...`;
                }
                
                return `${linkExternal}`
            }
        }
        
        if(type === ETypeTransactions.SUBSCRIPTION){
            const link = `${linkId}`
            
            if(link.length > 45){
                return `${link.slice(0, 44)}...`;
            }
            
            return link
        }
        
        if(type === ETypeTransactions.PIX){
            const link = linkId as string
            
            if(link.length > 25){
                return link.slice(0, 25) + "...";
            }
            
            return link
        }
    }
    
    const copyLinkToClipBoard = (): void => {
        if(type !== 1){
            copy(`${linkId}`);
            setButtonCopyText("Copiado");
        } else {
            copy(`${linkExternal}`);
            setButtonCopyText("Copiado")
        }
    }

    const downloadQRCode = (): void => {
        const canvas = document.getElementById("qr-gen") as HTMLCanvasElement;
        const pngUrl = canvas.toDataURL("image/png")
            .replace("image/png", "image/octet-stream");
        let downloadLink = document.createElement("a");
        
        downloadLink.href = pngUrl;
        downloadLink.download = "QR Code.png";
        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);
      };

    return (        
        <div className="modal fade" id={ modalId ? modalId : "exampleModal"}>
            <div className="modal-dialog modal-dialog-centered modal-success-message">
                <div className="modal-content">
                <div className="modal-header">
                    <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                        <img src={close} alt="fechar"/>
                    </button>
                </div>
                <div className="modal-body" id="modal-body">
                    <TextContainer>
                        <TextMessage>{text}</TextMessage>
                    </TextContainer>
                    {
                        qrCode ?
                            <QrCodeContainer>
                                <QRCode
                                    id="qr-gen"
                                    value={linkId as string}
                                    size={150}
                                    level={"L"}
                                    includeMargin={false}
                                />
                            </QrCodeContainer> 
                            : null
                    }
                    <LinkContainer>
                        <div style={{width: 285, display: "block"}}>
                            <ButtonLink onClick={() => copyLinkToClipBoard()}>
                                <ButtonLinkText>{linkDefinerAccordingToTheType()}</ButtonLinkText>
                                <ButtonLinkCopy>
                                    <img src={paper} style={{marginRight: 8}}/>
                                    {buttonCopyText}
                                </ButtonLinkCopy>
                            </ButtonLink>
                            {
                                qrCode
                                    ? <ButtonDownload onClick={downloadQRCode} >
                                            <img src={IconDownload} style={{marginRight: 8}}/>
                                            Baixar QR Code
                                        </ButtonDownload>
                                    : null
                            }
                            <ButtonShare color={colors.greenDark} onClick={() => sendWhatsapp()}>
                                <img src={whatsapp}/>
                                <ButtonShareText>Enviar para whatsapp</ButtonShareText>
                            </ButtonShare>
                            <ButtonShare color={colors.textRed} onClick={() => sendEmail()}>
                                <img src={mail}/>
                                <ButtonShareText>Enviar por email</ButtonShareText>
                            </ButtonShare>
                        </div>
                    </LinkContainer>  
                    <div className="d-flex justify-content-center">
                        {message !== "" ? message : null}
                    </div>            
                    
                </div>
                <ModalFooter className="modal-footer">
                    <Button style={{width: 284}} data-dismiss="modal">Finalizar</Button>
                </ModalFooter>
                </div>
            </div>
        </div>
    );
}

export default ModalShare;